<template>
	<component
		:is="tag"
		class="cms-heading-block"
		:style="headingStyle"
	>{{ text }}</component>
</template>

<script>
/**
 * HeadingBlock.vue
 * ────────────────
 * A heading block that renders an h1–h6 element with the configured text.
 *
 * Alignment, spacing, color overrides and other typography are style
 * TRAITS that the block wrapper applies to its own element. This block
 * only resolves the per-level site CSS variables and otherwise inherits
 * from the wrapper:
 *
 *   1. Level-specific site CSS variable  (--site-h2-color, etc.)
 *   2. Global heading variable           (--site-heading-color / -font)
 *   3. inherit                           (wrapper typography trait)
 */

import { buildHeadingLevelStyle } from '@/websites/cms/blocks/headingBlock/headingLevelStyle.js';

export default {
	name: 'HeadingBlock',

	props: {
		level: { type: String, default: 'h2' },
		text:  { type: String, default: 'Heading' }
	},

	computed: {
		tag: function () {
			var allowed = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
			return allowed.indexOf(this.level) !== -1 ? this.level : 'h2';
		},

		headingStyle: function () {
			return buildHeadingLevelStyle(this.tag);
		}
	}
};
</script>

<style scoped>
.cms-heading-block {
	margin: 0;
	width: 100%;
	max-width: 100%;
	text-align: inherit;
	word-wrap: break-word;
	overflow-wrap: break-word;
	min-height: 1em;
}
</style>
